<template>
  <div name="logical-statement-main">
    <list-view v-if="!list.flgEdit"
               :totalLists="totalLists"
               :list="list"
               :index="index"
               :linkList="linkList"
               :unlinkList="unlinkList"
               :ungroupList="ungroupList"
               :editList="editList"
               :deleteList="deleteList" />
    <list-edit v-if="list.flgEdit"
               :nowLang="nowLang"
               :labelCodsex="labelCodsex"
               :list="list"
               :index="index"
               :setDescConjAndDescStmt="setDescConjAndDescStmt"
               :viewList="viewList"
               :findValueType="findValueType"
               :findInputType="findInputType"
               :findLovType="findLovType"
               :listFields="listFields"
               :listConjunctions="listConjunctions"
               :listOperators="listOperators" />
  </div>
</template>

<script>
  import listView from 'components/hrmsLogicalStatement/listView'
  import listEdit from 'components/hrmsLogicalStatement/listEdit'
  export default {
    name: 'logical-statement-main',
    props: {
      nowLang: {
        type: String,
        default: 'th'
      },
      totalLists: {
        type: Number,
        default: 0
      },
      labelCodsex: {
        type: Object
      },
      list: {
        type: Object,
        required: true
      },
      index: {
        type: Number
      },
      setDescConjAndDescStmt: {
        type: Function
      },
      linkList: {
        type: Function
      },
      unlinkList: {
        type: Function
      },
      ungroupList: {
        type: Function
      },
      viewList: {
        type: Function
      },
      editList: {
        type: Function
      },
      deleteList: {
        type: Function
      },
      findValueType: {
        type: Function
      },
      findInputType: {
        type: Function
      },
      findLovType: {
        type: Function
      },
      listFields: {
        type: Array,
        required: true
      },
      listConjunctions: {
        type: Object,
        required: true
      },
      listOperators: {
        type: Array,
        required: true
      }
    },
    components: {
      listView,
      listEdit
    }
  }
</script>


// WEBPACK FOOTER //
// listMain.vue?1748ffd0